import styled from "styled-components";

const DescriptionBox = styled.div`
  font-size: 16px;
  line-height: 1.6;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;


  .poll {
    background: #f0f0f0;
    padding: 16px 20px;
    border-bottom: 1px solid #ddd;
    font-family: var(--font-semiBold);
    border-radius: 20px 20px 0 0;
    font-size: 24px;
  }

  .apolo{
    padding:10px 20px 10px;

    p{
    font-size:16px;}
  }
`;

const VehicleSpecs = ({ vehicle }: { vehicle: any }) => {
  return (
  <DescriptionBox>
  <div className="poll">
          {vehicle.year} {vehicle.make} {vehicle.model} {vehicle.trim} Description
        </div>
        <div className="apolo">
            <p>{vehicle.description || "No description available."}</p></div>
  </DescriptionBox>
);
  };
export default VehicleSpecs;
